import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const HealthcarePortalContent = ({ user, activeTab }) => {
  const renderTabContent = () => {
    switch (activeTab) {
      case 0: // Dashboard
        return (
          <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
              Healthcare Institution Dashboard
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Institutional overview and multi-site coordination.
            </Typography>
          </Container>
        );
      case 1: // Institution
        return (
          <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
              Institution Management
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Manage institutional settings and capabilities.
            </Typography>
          </Container>
        );
      case 2: // Partnerships
        return (
          <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
              Partnership Management
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Coordinate with partner healthcare institutions.
            </Typography>
          </Container>
        );
      case 3: // Compliance
        return (
          <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
              Compliance Tracking
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Monitor regulatory compliance and quality metrics.
            </Typography>
          </Container>
        );
      default:
        return (
          <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h5">Content Under Development</Typography>
          </Container>
        );
    }
  };

  return (
    <Box sx={{ minHeight: '100%' }}>
      {renderTabContent()}
    </Box>
  );
};

export default HealthcarePortalContent;